import React, { useEffect, useState } from "react";
import Logo from "../../../../assets/images/Dhell_Logo.png";
import { AiOutlineHome, AiOutlineArrowLeft } from "react-icons/ai";
import { PiUsersThreeThin } from "react-icons/pi";
import { FaUserTie, FaRegComments } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { CiSettings } from "react-icons/ci";
import { FcAcceptDatabase } from "react-icons/fc";
import { SiPayloadcms } from "react-icons/si";
import { FaArrowRight } from "react-icons/fa6";

const SideNav = () => {
  const [isActive, setIsActive] = useState(null);
  const [open, setOpen] = useState(true);
  const [isUsersSubMenuOpen, setIsUsersSubMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    let newValue = null;

    switch (currentPath) {
      case "/admin/home":
        newValue = 1;
        break;
      case "/admin/users":
        newValue = 2;
        break;
      case "/admin/specialists":
        newValue = 3;
        break;
      case "/admin/accepting-users":
        newValue = 4;
        break;
      case "/admin/accepting-specialists":
        newValue = 5;
        break;
      case "/admin/users-comments":
        newValue = 6;
        break;
      case "/admin/settings":
        newValue = 7;
        break;
      case "/admin/CMS-home-hero":
        newValue = 8;
        break;
      case "/admin/CMS-home-services":
        newValue = 9;
        break;
      case "/admin/CMS-services":
        newValue = 10;
        break;
      default:
        newValue = 1;
        break;
    }

    setIsActive(newValue);
  }, [location.pathname]);

  const toggleUsersSubMenu = () => {
    setIsUsersSubMenuOpen(!isUsersSubMenuOpen);
  };

  return (
    <div
      className={`${open ? "w-72" : "md:w-24 w-14"} duration-300 h-screen bg-white relative`}
    >
      <AiOutlineArrowLeft
        onClick={() => setOpen(!open)}
        className={`absolute cursor-pointer md:flex hidden -right-3 top-3 w-7 h-7 border-2 border-[#ffffff] text-white rounded-full bg-[#591f8b] ${!open && "rotate-180"}`}
      />

      <div className={`md:p-8 p-4 cursor-pointer duration-500 flex justify-center`}>
        <img src={Logo} alt='Logo' />
      </div>

      <div className='flex justify-start mt-16 md:ml-0 ml-2 pe-2'>
        <ul className="flex flex-col gap-8 mb-8">
          <Link to={"/admin/home"}>
            <div
              className={` flex flex-row ${isActive !== 1 && "ps-11"} ${isActive === 1 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <AiOutlineHome className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Home
              </li>
            </div>
          </Link>

          <Link to={"/admin/users"}>
            <div
              className={`flex flex-row ${isActive !== 2 && "ps-11"} ${isActive === 2 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <PiUsersThreeThin className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Users
              </li>
            </div>
          </Link>

          <Link to={"/admin/specialists"}>
            <div
              className={`flex flex-row ${isActive !== 3 && "ps-11"} ${isActive === 3 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <FaUserTie className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Specialists
              </li>
            </div>
          </Link>

          <Link to={"/admin/accepting-users"}>
            <div
              className={`flex flex-row ${isActive !== 4 && "ps-11"} ${isActive === 4 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <FcAcceptDatabase className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Accepting Users
              </li>
            </div>
          </Link>

          <Link to={"/admin/accepting-specialists"}>
            <div
              className={`flex flex-row ${isActive !== 5 && "ps-11"} ${isActive === 5 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <FcAcceptDatabase className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Accepting Specialists
              </li>
            </div>
          </Link>
          <Link to={"/admin/users-comments"}>
            <div
              className={`flex flex-row ${isActive !== 6 && "ps-11"} ${isActive === 6 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <FaRegComments className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Users Comments
              </li>
            </div>
          </Link>
          <Link to={"/admin/settings"}>
            <div
              className={`flex flex-row ${isActive !== 7 && "ps-11"} ${isActive === 7 &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                }`}
            >
              <CiSettings className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
              <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                Settings
              </li>
            </div>
          </Link>

          {/* CMS sub-menu */}
          <div>
            <div
              onClick={toggleUsersSubMenu}
              className={`flex flex-row ${(isActive !== 8 &&  isActive !== 9 && isActive !== 10) && "ps-11"} ${(isActive === 8 ||  isActive === 9 || isActive === 10) &&
                "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
                } cursor-pointer`}
            >
              <SiPayloadcms className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />

              <div className="flex justify-center items-center">
                <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
                  CMS
                </li>
                <FaArrowRight className='ms-2 w-4 h-4' />
              </div>
            </div>
            {/* Sub-menu items */}
            {isUsersSubMenuOpen && (
              <ul className={`pl-28 mt-2 ${!open && "hidden"} flex flex-col gap-4`}>
                <Link to="/admin/CMS-home-hero">
                  <li className={`flex items-center ${isActive === 8 && "text-primary"}`}>Home Hero</li>
                </Link>
                <Link to="/admin/CMS-home-services">
                  <li className={`flex items-center ${isActive === 9 && "text-primary"}`}>Home services</li>
                </Link>
                <Link to="/admin/CMS-services">
                  <li className={`flex items-center ${isActive === 10 && "text-primary"}`}>Services</li>
                </Link>
              </ul>
            )}
          </div>

          {/* Other menu items can be added here */}
        </ul>
      </div>
    </div>
  );
};

export default SideNav;


// import React, { useEffect, useState } from "react";
// import Logo from "../../../../assets/images/Dhell_Logo.png";
// import { AiOutlineHome, AiOutlineArrowLeft } from "react-icons/ai";
// import { PiUsersThreeThin } from "react-icons/pi";
// import { FaUserTie, FaRegComments  } from "react-icons/fa";
// import { Link, useLocation } from "react-router-dom";
// import { CiSettings } from "react-icons/ci";
// import { FcAcceptDatabase } from "react-icons/fc";
// import { SiPayloadcms } from "react-icons/si";

// const SideNav = () => {
//   const [isActive, setIsActive] = useState(null);

//   const [open, setOpen] = useState(true);
//   const location = useLocation();

//   useEffect(() => {
//     const currentPath = location.pathname;

//     let newValue = null;

//     switch (currentPath) {
//       case "/admin/home":
//         newValue = 1;
//         break;
//       case "/admin/users":
//         newValue = 2;
//         break;
//       case "/admin/specialists":
//         newValue = 3;
//         break;
//       case "/admin/accepting-users":
//         newValue = 4;
//         break;
//       case "/admin/accepting-specialists":
//         newValue = 5;
//         break;
//       case "/admin/users-comments":
//         newValue = 6;
//         break;
//       case "/admin/settings":
//         newValue = 7;
//         break;
//       case "/admin/CMS":
//         newValue = 8;
//         break;
//       default:
//         newValue = 1;
//         break;
//     }

//     setIsActive(newValue);
//   }, [location.pathname]);

//   return (
//     <div
//       className={`${open ? "w-72" : "md:w-24 w-14"
//         } duration-300 h-screen bg-white relative`}
//     >
//       <AiOutlineArrowLeft
//         onClick={() => setOpen(!open)}
//         className={` absolute cursor-pointer md:flex hidden -right-3 top-3 w-7 h-7 border-2 border-[#ffffff] text-white rounded-full bg-[#591f8b] ${!open && "rotate-180"
//           }`}
//       />

//       <div
//         className={`md:p-8 p-4 cursor-pointer duration-500 flex justify-center`}
//       >
//         <img src={Logo} alt='Logo' />
//       </div>

//       <div className='flex justify-start mt-16 md:ml-0 ml-2 pe-2'>
//         <ul className="flex flex-col gap-8 mb-8">
//           <Link to={"/admin/home"}>
//             <div
//               className={` flex flex-row ${isActive !== 1 && "ps-11"} ${isActive === 1 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <AiOutlineHome className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Home
//               </li>
//             </div>
//           </Link>

//           <Link to={"/admin/users"}>
//             <div
//               className={`flex flex-row ${isActive !== 2 && "ps-11"} ${isActive === 2 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <PiUsersThreeThin className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Users
//               </li>
//             </div>
//           </Link>

//           <Link to={"/admin/specialists"}>
//             <div
//               className={`flex flex-row ${isActive !== 3 && "ps-11"} ${isActive === 3 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <FaUserTie className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Specialists
//               </li>
//             </div>
//           </Link>

//           <Link to={"/admin/accepting-users"}>
//             <div
//               className={`flex flex-row ${isActive !== 4 && "ps-11"} ${isActive === 4 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <FcAcceptDatabase className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Accepting Users
//               </li>
//             </div>
//           </Link>

//           <Link to={"/admin/accepting-specialists"}>
//             <div
//               className={`flex flex-row ${isActive !== 5 && "ps-11"} ${isActive === 5 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <FcAcceptDatabase className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Accepting Specialists
//               </li>
//             </div>
//           </Link>
//           <Link to={"/admin/users-comments"}>
//             <div
//               className={`flex flex-row ${isActive !== 6 && "ps-11"} ${isActive === 6 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <FaRegComments className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Users Comments
//               </li>
//             </div>
//           </Link>
//           <Link to={"/admin/settings"}>
//             <div
//               className={`flex flex-row ${isActive !== 7 && "ps-11"} ${isActive === 7 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <CiSettings  className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 Settings
//               </li>
//             </div>
//           </Link>

//           <Link to={"/admin/CMS"}>
//             <div
//               className={`flex flex-row ${isActive !== 8 && "ps-11"} ${isActive === 8 &&
//                 "text-primary md:before:mr-6 md:before:h-0 md:before:w-0 md:before:border-t-[16px] md:before:border-t-transparent md:before:border-b-[16px] md:before:border-b-transparent md:before:border-l-[20px] md:before:mt-1  md:before:border-primary"
//                 }`}
//             >
//               <SiPayloadcms  className='p-2 bg-blue-gray-50 rounded-full cursor-pointer w-11 h-11' />
//               <li className={`ml-6 flex items-center ${!open && "hidden"}`}>
//                 CMS
//               </li>
//             </div>
//           </Link>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default SideNav;
